<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: luoxi
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-02-02 09:47:09
 -->
<template>
  <div class="side">
    <template v-if="states == 1">
      <Menu />
    </template>
    <template v-else>
      <Firstregist />
    </template>
  </div>
</template>

<script>
import Menu from "./menu";
import Firstregist from "./firstregist";
import Bus from "@/plugins/upload/bus";
// import Disk from './disk'
export default {
  inject: ["reload"],
  components: {
    Menu,
    Firstregist,
  },
  data() {
    return {
      states:2,
    };
  },
  watch: {
    // 方法1
    $route(to, from) {
      //监听路由是否变化
      if (
        to.path == "/web/myinfo" ||
        to.path == "/web/regisactive" ||
        to.path == "/web/resetpassword"
      ) {
        //跳转到哪个页面
        this.states = 2;
      }
      if (
        to.path == "/web/home" ||
        to.path == "/web/fileshare" ||
        to.path == "/web/examine" ||
        to.path == "/web/webpay" ||
        to.path == "/web/payselect"
      ) {
        this.states = 1;
      }
    },
  },
  created() {
    
  },
  computed: {},
  mounted() {
    if (!localStorage.getItem("states")) {
      this.states = 2;
    } else {
      this.states = localStorage.getItem("states");
    }
    this.getPath()
  },
  methods: {
    getPath(){
      if (
        this.$route.path == "/web/myinfo" ||
       this.$route.path == "/web/regisactive" ||
        this.$route.path== "/web/resetpassword"
      ) {
        //跳转到哪个页面
        this.states = 2;
      }
      if (
       this.$route.path == "/web/home" ||
      this.$route.path == "/web/fileshare" ||
     this.$route.path == "/web/examine" ||
     this.$route.path == "/web/webpay" ||
      this.$route.path== "/web/payselect"
      ) {
        this.states = 1;
        
      }
     
    },
    
  },
};
</script>

<style scoped="" lang="scss">
.side {
  width: 194px;
  // background: #1872c4;
  background-image: url("../../assets/images/bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  box-shadow: 0px 0px 6px 0px rgba(43, 43, 43, 0.05);
  position: relative;
  .radio {
    position: absolute;
    bottom: 80px;
    width: 100%;
    text-align: center;
  }
}
</style>
